import { GlAnimatedSidebarIcon, GlButton, GlTooltip } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mapActions, mapState } from '../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { keyboardShortcutsDisabled } from '~/behaviors/shortcuts/shortcuts_disabled';
import { __ } from '~/locale';
import { keysFor, MR_TOGGLE_FILE_BROWSER, MR_FOCUS_FILE_BROWSER } from '~/behaviors/shortcuts/keybindings';
import { useFileBrowser } from '../stores/file_browser.js?vue3';
import { Mousetrap } from '~/lib/mousetrap';
import Shortcut from '../../behaviors/shortcuts/shortcut.vue?vue3';
export default {
    name: 'FileBrowserToggle',
    MR_TOGGLE_FILE_BROWSER,
    components: {
        GlButton,
        GlAnimatedSidebarIcon,
        GlTooltip,
        Shortcut
    },
    props: {
        bindFocusShortcut: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        ...mapState(useFileBrowser, [
            'fileBrowserVisible'
        ]),
        toggleFileBrowserShortcutKey () {
            return this.shortcutsEnabled ? keysFor(MR_TOGGLE_FILE_BROWSER)[0] : null;
        },
        shortcutsEnabled () {
            return !keyboardShortcutsDisabled();
        },
        toggleFileBrowserTitle () {
            return this.fileBrowserVisible ? __('Hide file browser') : __('Show file browser');
        }
    },
    created () {
        this.initFileBrowserVisibility();
    },
    mounted () {
        if (this.shortcutsEnabled) {
            if (this.bindFocusShortcut) {
                Mousetrap.bind(keysFor(MR_FOCUS_FILE_BROWSER), this.focusFileBrowser);
            }
            Mousetrap.bind(keysFor(MR_TOGGLE_FILE_BROWSER), this.toggleFileBrowserVisibility);
        }
    },
    beforeDestroy () {
        if (this.shortcutsEnabled) {
            if (this.bindFocusShortcut) {
                Mousetrap.unbind(keysFor(MR_FOCUS_FILE_BROWSER));
            }
            Mousetrap.unbind(keysFor(MR_TOGGLE_FILE_BROWSER));
        }
    },
    methods: {
        ...mapActions(useFileBrowser, [
            'toggleFileBrowserVisibility',
            'setFileBrowserVisibility',
            'initFileBrowserVisibility',
            'requestSearchFocus'
        ]),
        focusFileBrowser (event) {
            // event is empty when testing using Mousetrap.trigger
            event?.preventDefault?.();
            this.setFileBrowserVisibility(true);
            this.requestSearchFocus();
        }
    }
};
